import React, {JSXElementConstructor} from 'react';
import * as R from 'ramda';
import {
  filterXSS,
  getDefaultWhiteList,
  IFilterXSSOptions,
  IWhiteList,
} from 'xss';

// https://github.com/leizongmin/js-xss for second param options
export function SecureHtml<
  T extends keyof JSX.IntrinsicElements | JSXElementConstructor<any>
>({
  component: Component = 'div',
  html,
  options = {},
  adaptWhitelist = R.identity,
  ...props
}: React.ComponentProps<T> & {
  component: React.ElementType<T>;
  html: string;
  options?: IFilterXSSOptions;
  adaptWhitelist?: (current: IWhiteList) => IWhiteList;
}) {
  return (
    <Component
      dangerouslySetInnerHTML={{
        __html: filterXSS(html, {
          ...options,
          whiteList: adaptWhitelist(getDefaultWhiteList()),
          stripIgnoreTag: true,
          stripIgnoreTagBody: true,
        }),
      }}
      {...props}
    />
  );
}

/**
 * The XSS library whitelist defaults don't include any style attributes.
 * This utility fn takes a list of tags and whitelists the style attribute on them.
 * Intended for use with the SecureHtml prop adaptWhitelist.
 */
export const addStyleAttrToWhiteListTags =
  (tags: Array<keyof IWhiteList>) => (defaultWhitelist: IWhiteList) => {
    const whitelist = R.clone(defaultWhitelist);
    tags.forEach(tag => whitelist[tag]?.push('style'));
    return whitelist;
  };
